import React, { useEffect, useState } from 'react'
import { Item } from '../../../common/snippets'
import { AcountingHeading } from '../common/AcountingHeading'
import { Box, Button } from '@mui/material'
import DropDownOA from '../../../common/dropDownOA'
import Datepicker from '../../../common/datePicker'
import * as sx from '../../../common/stylesInline/report_daily_branch'
import { RefreshSvg } from '../../../common/svg/refresh'
import { SplitButton } from '../../../common/SplitButton'
import { reportViewDispatchFilter } from '../../../common/constants'
import * as id from '../../Reports/reportId'
import { connect } from 'react-redux'
import { getHisabReportDropData } from '../../../../store/Acounting/acounting_action'
import moment from 'moment'
import { updateAlert } from '../../../../store/common/common_action'
import { appendToUrl, focusElemnt, navigation3 } from '../../../common/helper'
import * as urls from '../../Reports/oldReportsUrls'
import { detailedSubHeading, summaryHeaderColumn } from './HisabConstant'
import { GetRequest } from '../../../common/api'
import { urls as apiUrls } from '../../../common/constants'
import { useSearchParams } from 'react-router-dom'
import useToken from '../../../helpers/useTokens'
import { downloadPDF } from '../../Reports/analysisReport/pdfAutotable'

const HisabReportNew = (props) => {
    const {
        data: { common, acountingReducer },
        getHisabReportDropData,
        updateAlert,
    } = props

    const [searchParams] = useSearchParams()
    let { loginData: tokenLoginData = {} } = useToken()
    let loginData = common?.loginData || tokenLoginData
    const hasUrlLoginData = searchParams.has('C') || searchParams.has('B') || searchParams.has('U')
    let isFromUrl = false
    if ((!loginData || Object.keys(loginData).length === 0) && hasUrlLoginData) {
        loginData = {}
        loginData.intCompanyID = searchParams.get('C') || 0
        loginData.intBranchCityID = searchParams.get('CT') || 0
        loginData.strCityName = searchParams.get('CTN') || 0
        loginData.intUserID = searchParams.get('U') || 0
        loginData.intBranchID = searchParams.get('B') || 0
        loginData.strCompanyName = searchParams.get('CN') || ''
        loginData.strUserName = searchParams.get('UN') || ''
        loginData.strBranchName = searchParams.get('BN') || ''
        loginData.IsBranchAdmin = searchParams.get('IBA') || 0
        loginData.IsMTPLAdmin = searchParams.get('IMPTLA') || 0
        loginData.IsAdmin = searchParams.get('IA') || 0
        loginData.BusCrsCheckSum = searchParams.get('chk') || searchParams.get('CHK') || ''
        isFromUrl = true
    }
    const { hisabReportDropData } = acountingReducer
    const reportName = 'Generate Hisab'
    const [reportView, setReportView] = useState(reportViewDispatchFilter?.[0])
    const [fromDate, setFromDate] = useState(moment(new Date()))
    const [toDate, setToDate] = useState(moment(new Date()))
    const [vehicleNo, setVehicleNo] = useState('')
    const [resetFlag, setResetFlag] = useState(false)

    const criteriaHeaders = [
        { field: 'fromDate', header: 'From Date', textAlign: 'left' },
        { field: 'toDate', header: 'To Date', textAlign: 'left' },
        { field: 'vehicleNo', header: 'Vehicle No.', textAlign: 'left' },
        { field: 'reportView', header: 'Report View', textAlign: 'left' },
    ]

    const criteriaData = {
        fromDate: moment(fromDate).format('DD-MM-YYYY'),
        toDate: moment(toDate).format('DD-MM-YYYY'),
        vehicleNo: vehicleNo?.VehicleNo || '',
        reportView: reportView?.Name || '',
        dataType: 'entry',
    }

    const getMainHeader = (columns = []) =>
        columns.map((column) => {
            const header = column.headerName || column.header || ''
            return {
                ...column,
                header,
                exportHead: column.exportHead || header,
                align: column.align || (column?.xlCol?.dataType === 'string' ? 'left' : 'right'),
                weight: column?.weight || 100,
            }
        })

    const openViewReport = (reportPayload) => {
        const rid = `${Date.now()}-${Math.random().toString(36).slice(2, 8)}`

        if (!window.generatedReports) {
            window.generatedReports = {}
        }

        window.generatedReports[rid] = reportPayload
        const reportUrl = `/view-report?rid=${rid}`

        window.open(reportUrl, '_blank')
    }

    const buildSummaryPayload = (summaryData = []) => ({
        reportName: `${reportName} (Summary)`,
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: summaryData.map((item) => ({
            ...item,
            dataType: 'entry',
        })),
        mainHeader: getMainHeader(summaryHeaderColumn),
        isIncreFontSize: true,
    })

    const getDetailedTableData = (detailRows = []) => {
        const groupedRows = detailRows.reduce((acc, item) => {
            const key = item?.HisabNo || ''
            if (!acc[key]) {
                acc[key] = []
            }
            acc[key].push(item)
            return acc
        }, {})

        return Object.values(groupedRows).flatMap((group) => {
            const totalAmount = group.reduce((sum, item) => sum + (parseFloat(item?.Freight) || 0), 0)
            const totalParcel = group.reduce((sum, item) => sum + (parseFloat(item?.Items) || 0), 0)
            const lessCommission = group.reduce((sum, item) => sum + (parseFloat(item?.PCT) || 0), 0)
            const currentHisab = group[0] || {}

            return [
                {
                    LRNo: `Vehicle No : ${vehicleNo?.VehicleNo || ''}`,
                    ToStation: `Hisab / Voucher No : ${currentHisab?.HisabNo || ''}`,
                    Remarks: `Hisab / Voucher Date : ${currentHisab?.HisabDate || ''}`,
                    dataType: 'subHeader',
                    backgroundColor:'#BFE1FF',
                    colSpan: {
                        LRNo: 2,
                        ToStation: 2,
                        Remarks: 2,
                    },
                    align: {
                        LRNo: 'left',
                        ToStation: 'center',
                        Remarks: 'right',
                    },
                },
                {
                    LRNo: 'LR No.',
                    ChallanNo: 'Challan No.',
                    ToStation: 'To Station',
                    Items: 'No. of Parcel/Cover',
                    Remarks: 'Remarks',
                    Freight: 'Amount',
                    dataType: 'header',
                },
                ...group.map((item) => ({
                    ...item,
                    dataType: 'entry',
                })),
                {
                    LRNo: 'TOTAL BOOKINGS',
                    Items: totalParcel,
                    Remarks: '-',
                    Freight: Math.round(totalAmount),
                    dataType: 'total',
                    colSpan: {
                        LRNo: 3,
                    },
                    align: {
                        LRNo: 'right',
                        Items: 'right',
                        Remarks: 'left',
                        Freight: 'right',
                    },
                },
                {
                    LRNo: 'LESS COMISSION',
                    Freight: Math.round(lessCommission),
                    dataType: 'total',
                    colour:'red',
                    colSpan: {
                        LRNo: 5,
                    },
                    align: {
                        LRNo: 'right',
                        Freight: 'right',
                    },
                },
                {
                    LRNo: `NET OUTSTANDING - VEHICLE NO : ${vehicleNo?.VehicleNo || ''}, HISAB / VOUCHER NO : ${currentHisab?.HisabNo || ''}`,
                    Freight: Math.round(totalAmount) - Math.round(lessCommission),
                    dataType: 'total',
                    colSpan: {
                        LRNo: 5,
                    },
                    align: {
                        LRNo: 'right',
                        Freight: 'right',
                    },
                },
            ]
        })
    }

    const buildDetailedPayload = (detailRows = []) => ({
        reportName: `${reportName} (Detailed)`,
        criteriaHeaders,
        criteriaData: [criteriaData],
        tableData: getDetailedTableData(detailRows),
        mainHeader: getMainHeader(detailedSubHeading),
        hideHeader: true,
        isIncreFontSize: true,
    })

    const getSummaryReportData = async (requestBody) => {
        const res = await GetRequest(apiUrls.getGenerateHisabReportSummary, requestBody)
        if (res?.status !== 'Success') {
            updateAlert({ show: true, msg: res?.ErrMessage || 'No Data', nextId: '' })
            return null
        }
        return res?.Data?.Table || []
    }

    const getDetailedReportData = async (requestBody) => {
        const res = await GetRequest(apiUrls.getGenerateHisabReportDetailed, requestBody)
        if (res?.status !== 'Success') {
            updateAlert({ show: true, msg: res?.ErrMessage || 'No Data', nextId: '' })
            return null
        }
        return res?.Data?.Table || []
    }
    const handleClick1 = async (isPdf = false) => {
        if (vehicleNo === '' || vehicleNo === " ") {
            updateAlert({ show: true, msg: 'Please Select Vehicle No.' })
            return
        }

        const obj = {
            CompanyID: loginData?.intCompanyID,
            BranchID: loginData?.intBranchID,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
            VehicleNo: vehicleNo?.VehicleNo,
            UserID: loginData?.intUserID,
            VehicleID: vehicleNo?.VehicleID,
        }
        if (reportView?.id === 0) {
            const summaryData = await getSummaryReportData(obj)
            if (!summaryData?.length) {
                 updateAlert({ show: true, msg: 'No Data Found', nextId: '' })
                return
            }

            const reportPayload = buildSummaryPayload(summaryData)
            if (isPdf === true) {
                downloadPDF({
                    ...reportPayload,
                    visibleColumns: reportPayload.mainHeader,
                    loginData,
                    hideHeader: false,
                })
                return
            }
            openViewReport(reportPayload)
        } else if (reportView?.id === 1) {
            const summaryRows = await getSummaryReportData(obj)

            if (!summaryRows?.length) {
                return
            }

            const hisabNo = [...new Set(summaryRows.map((item) => item?.HisabNo).filter(Boolean))].join('^')

            if (!hisabNo) {
                updateAlert({ show: true, msg: 'No Data', nextId: '' })
                return
            }

            const object = {
                CompanyID: loginData?.intCompanyID,
                BranchID: loginData?.intBranchID,
                HisabNos: hisabNo,
                dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
                dtToDate: moment(toDate).format('YYYY-MM-DD'),
                VehicleNo: vehicleNo?.VehicleNo,
            }

            const detailRows = await getDetailedReportData(object)

            if (!detailRows?.length) {
                 updateAlert({ show: true, msg: 'No Data Found', nextId: '' })
                return
            }

            const reportPayload = buildDetailedPayload(detailRows)
            if (isPdf === true) {
                downloadPDF({
                    ...reportPayload,
                    visibleColumns: reportPayload.mainHeader,
                    loginData,
                })
                return
            }
            openViewReport(reportPayload)
        }
    }

    const getFilterData = () => {
        const obj = {
            CompanyID: loginData?.intCompanyID,
            BranchID: loginData?.intBranchID,
            dtFromDate: moment(fromDate).format('YYYY-MM-DD'),
            dtToDate: moment(toDate).format('YYYY-MM-DD'),
        }
        getHisabReportDropData(obj)
    }

    const handleClick2 = () => {
        if (!vehicleNo?.VehicleNo) {
            updateAlert({ show: true, msg: 'Please Select Vehicle No.' })
            return
        }

        if (reportView?.id === 1) {
            updateAlert({ show: true, msg: 'Detail View is Not Available in Old Format.' })
        } else {
            let url = urls.generateHisabReport
            let urlData = urls.generateHisabReportParams
            urlData.chk = loginData.BusCrsCheckSum
            urlData.FromDt = moment(fromDate).format('DD-MMM-YYYY')
            urlData.ToDt = moment(toDate).format('DD-MMM-YYYY')
            urlData.VehicleNo = vehicleNo?.VehicleNo
            urlData.VehicleID = vehicleNo?.VehicleID
            urlData.intAllowExportToExcel = 1
            url = appendToUrl(url, urlData)
            window.open(url, '_blank')
        }
    }

    const reset = () => {
        setFromDate(moment(new Date()))
        setToDate(moment(new Date()))
        setVehicleNo('')
        setResetFlag(!resetFlag)
        setReportView(reportViewDispatchFilter?.[0])
    }

    useEffect(() => {
        focusElemnt('fromDate')
    }, [])

    return (
        <>
            <Item sx={{ padding: '0' }} className="reports">
                {isFromUrl && <style>{`.global-header { display: none; } #root { zoom: 1.2; }`}</style>}
                {isFromUrl ? <></> : <AcountingHeading reportName={reportName} />}
                <Box sx={sx.reportFlex}>
                    {isFromUrl ? <></> : <>
                    <Item sx={sx.itemsx}>
                        <DropDownOA id={'selectCompany'} label={'Select Company'} defaultvalue={loginData.strCompanyName} disabled={true} width="100%" />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button variant="contained" disabled={true} style={{ ...sx.fullHeight, ...sx.novp }} className="btn btn-primary">
                            GO
                        </Button>
                    </Item>
                    </>}
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={`From Date`}
                            name={'from_date'}
                            id={'fromDate'}
                            nextId={'toDate'}
                            prevId={'fromDate'}
                            value={fromDate}
                            dateChange={(date) => {
                                setFromDate(date)
                                focusElemnt('toDate')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? { ...sx.itemsxGrow, width: '60%' } : sx.itemsx} className="input--container bookingDatePicker">
                        <Datepicker
                            label={'To Date'}
                            name={'to_date'}
                            id={'toDate'}
                            value={toDate}
                            nextId={'GoBtn'}
                            prevId={'fromDate'}
                            dateChange={(date) => {
                                setToDate(date)
                                focusElemnt('GoBtn')
                            }}
                            width="100%"
                        />
                    </Item>
                    <Item sx={sx.itemsx} className="disabled-wrapper">
                        <Button
                            id="GoBtn"
                            variant="contained"
                            nextId={'SelectVehicleNo'}
                            prevId={'toDate'}
                            style={{ ...sx.fullHeight, ...sx.novp }}
                            className="btn btn-primary"
                            onClick={() => {
                                getFilterData()
                            }}
                            onKeyDown={(e) => navigation3(e, 'SelectVehicleNo', 'toDate', getFilterData)}
                        >
                            GO
                        </Button>
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={'SelectVehicleNo'}
                            label={'Select Vehicle No.'}
                            data={hisabReportDropData}
                            resetFlag={resetFlag}
                            nextId={'reportView'}
                            prevId={'GoBtn'}
                            idKey={`VehicleID`}
                            dataKey={`VehicleNo`}
                            onSelect={(val) => {
                                setVehicleNo(val)
                            }}
                            isObjArr={true}
                            searchPlaceholder={`Search Report`}
                            width="100%"
                        />
                    </Item>
                    <Item sx={isFromUrl ? sx.itemsxGrow : sx.itemsx}>
                        <DropDownOA
                            id={'reportView'}
                            nextId={'SplitBtn'}
                            prevId={'SelectVehicleNo'}
                            label={'Report View'}
                            data={reportViewDispatchFilter}
                            defaultvalue={reportView?.Name || reportViewDispatchFilter}
                            idKey={`id`}
                            dataKey={`Name`}
                            onSelect={(val) => {
                                setReportView(val)
                            }}
                            searchPlaceholder={`Search By Report Type`}
                            width={isFromUrl ? '100%' : '150px'}
                        />
                    </Item>
                    {isFromUrl ?
                        <Button variant="contained" sx={{ width: '100%', height: '40px', marginBottom: '10px' }} className="btn btn-primary" onClick={() => handleClick1(true)} id1={'SplitBtn'}>
                            DOWNLOAD PDF
                        </Button> :
                        <>
                    <Item
                        sx={sx.itemsx}
                        style={{ cursor: 'pointer' }}
                        onKeyDown={(e) => navigation3(e, 'fromDate', 'reportView', () => handleClick1())}
                    >
                        <SplitButton
                            id1={'SplitBtn'}
                            prevID={id.anReportOptions}
                            options={['GENERATE NEW FORMAT', 'GENERATE OLD FORMAT']}
                            onClick1={handleClick1}
                            onClick2={handleClick2}
                        />
                    </Item>
                    <Item sx={{ ...sx.itemsx }} style={{ cursor: 'pointer' }} onClick={() => reset()}>
                        <RefreshSvg />
                    </Item>
                    </>}
                </Box>
            </Item>
        </>
    )
}

const mapStateToProps = (data) => ({ data })
const mapDispatchToProps = {
    getHisabReportDropData,
    updateAlert,
}

export default connect(mapStateToProps, mapDispatchToProps)(HisabReportNew)
